module.exports = __webpack_public_path__ + "static/img/milford-amare.364c82f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/milford-amare.jpg
// module id = R/Od
// module chunks = 0